module.exports = __webpack_public_path__ + "static/media/blrss7.e62034c0.png";